export const newsArticles = [
  {
    id: 5,
    title: "MVE: prórroga al 31 de octubre y calendario por régimen",
    date: "2 de Octubre, 2026",
    excerpt: "El SAT, la ANAM y la ATDT extendieron la transición de la Manifestación de Valor Electrónica, que se presenta por la VUTCE, al 31 de octubre de 2026. La obligación entra por régimen desde el 1 de noviembre; para importación definitiva, desde el 15 de enero de 2027.",
    href: "/que-es-manifestacion-de-valor-electronica#calendario"
  },
  {
    id: 6,
    title: "VUTCE, antes VUCEM: la nueva ventanilla única",
    date: "4 de Mayo, 2026",
    excerpt: "Por decreto publicado el 4 de mayo de 2026, la Ventanilla Única de Trámites de Comercio Exterior (VUTCE) sustituye a VUCEM desde el 5 de mayo. Ahora la administra la Agencia de Transformación Digital y Telecomunicaciones (ATDT) en lugar del SAT.",
    href: "/que-es-manifestacion-de-valor-electronica#vutce"
  },
  {
    id: 1,
    title: "Nuevas Regulaciones Aduaneras 2024",
    date: "15 de Julio, 2024",
    excerpt: "Descubre los cambios más importantes en las regulaciones aduaneras que impactarán tus operaciones este año."
  },
  {
    id: 2,
    title: "Optimización de Procesos con Anexo 24",
    date: "10 de Julio, 2024",
    excerpt: "Conoce cómo la correcta implementación del Anexo 24 puede reducir costos y mejorar la eficiencia de tu inventario."
  },
  {
    id: 3,
    title: "Tendencias en Logística Internacional",
    date: "05 de Julio, 2024",
    excerpt: "Exploramos las tendencias emergentes en logística y transporte que están transformando el comercio global."
  },
  {
    id: 4,
    title: "VUCEM: Digitalización y Eficiencia",
    date: "01 de Julio, 2024",
    excerpt: "La Ventanilla Única de Comercio Exterior Mexicana sigue evolucionando. Te contamos las últimas actualizaciones."
  }
];